<template>
  <div v-loading="loading">
    <div class="responsive-table" id="table-wrapper">
      <table class="custom-table responsive-table border-collapse">
        <thead>
          <tr class="shadow-md rounded-lg">
            <th class="checkbox">
              <base-checkbox v-model="selectAll" />

            </th>
            <th>Group Name</th>
            <th>Descriptions</th>
            <th>Reason For Deactivation</th>
            <th>Date Deactivated</th>
            <th class="relative actions" tabindex="-1">
              <span class="cursor-pointer">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.7">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51" />
                  </g>
                </svg></span>
            </th>
          </tr>
        </thead>
        <tbody v-if="!fetchingGroups && filteredGroups.length == 0">
          <tr>
            <td colspan="6">
              <empty-table-icon />
              <p class="text-center pt-3 pb-5">No Deactivated Groups found!</p>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr v-if="fetchingGroups">
            <td></td>
            <td></td>
            <td>
              <loader />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr v-else v-for="group in filteredGroups" :key="group.id" class="shadow-md rounded-lg">
            <td>
              <base-checkbox v-model="selectedGroupIds" :value="group.id" />
            </td>
            <td>{{ group.name }}</td>
            <td>{{ group.description }}</td>
            <td>{{ group.deactivationReason }}</td>
            <td>{{ group.updatedAt | formatDate }}</td>
            <td class="table__action-btn cursor-pointer" tabindex="-1" @blur="selectedRowId = null">
              <span @click="showActionOptions(group.id)">
                <vertical-ellipsis />
              </span>
              <div class="table__action-options" v-if="selectedRowId == group.id">
                <div class="table__action-option cursor-pointer" @click="reactivateGroup(group.id)">
                  <p>Reactivate</p>
                </div>
                <div class="table__action-option cursor-pointer" @click="showDeleteModal(group.id)">
                  <p>Delete Group</p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination-control />
  </div>
</template>

<script>
import PaginationControl from "@/components/UI/NewPagination";
export default {
  components: {
    PaginationControl,
  },
  props: ["deactivatedGroups", "fetchingGroups"],
  data() {
    return {
      selectedRowId: null,
      selectedOption: "functional",
      options: [
        { value: "functional", text: "Functional" },
        { value: "management", text: "Management" },
        { value: "projects", text: "Projects" },
      ],
      loading: false,
      selectedGroupIds: [],
      selectAll: false,
    };
  },
  watch: {
    selectAll() {
      if (this.selectAll) {
        this.selectedGroupIds = [];
        this.filteredGroups.forEach((group) => {
          this.selectedGroupIds.push(group.id);
        });
      } else {
        this.selectedGroupIds = [];
      }
    },
    UGQueryString(value) {
      this.queryString = value;
    },
    UGQuerySortList(value) {
      this.sortList = value;
    },
  },
  computed: {
    filteredGroups() {
      let groups = this.filterArray(this.deactivatedGroups, this.queryString);
      return this.sortList
        ? groups.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        })
        : groups;
    },
    UGQueryString() {
      return this.$store.getters.getUserAndGroupsQuery;
    },
    UGQuerySortList() {
      return this.$store.getters.userAndGroupSortList;
    },
  },
  methods: {
    async reactivateGroup(groupId) {
      this.generateToast("Reactivating group...", "success");
      try {
        this.loading = true;
        let response = await this.$_reactivateGroup({ "id": groupId, "isActive": true });
        console.log(response);
        this.loading = false;
        this.generateToast("Group Reactivated!", "success");
        this.updateGroups();
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    async deleteMultipleGroups() {
      this.loading = true;
      let payload = this.createPayload();
      this.generateToast("Deleting Groups...", "success");
      try {
        let response = await this.$_deleteMultipleGroups(payload);
        console.log(response);
        this.loading = false;
        this.generateToast("Groups have been deleted!", "success");
        this.updateGroups();
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    async reactivateMultipleGroups() {
      let payload = this.createPayload();
      this.loading = true;
      this.generateToast("Reactivating Groups...!", "success");
      try {
        let response = await this.$_reactivateMultipleGroups(payload);
        console.log(response);
        this.loading = false;
        this.generateToast("Groups have been reactivated!", "success");
        this.updateGroups();
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    updateGroups() {
      this.$emit("update-deactivated-groups");
      this.$store.dispatch("resetAllGroups");
    },
    createPayload() {
      // converts array of user ID's into the array of object format expected by the endpoint
      let payload = [];
      this.selectedGroupIds.forEach((id) => {
        let groupIdObject = {};
        groupIdObject.groupId = id;
        payload.push(groupIdObject);
      });
      return payload;
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    showDeleteModal(groupId) {
      this.$emit("show-delete-modal", ["Group", groupId]);
      this.resetSelectedRow();
    },
    showViewRoleModal() {
      this.$emit("show-view-role-modal");
      this.resetSelectedRow();
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>
